import React from 'react';
import { useId as useJoyId } from '@withjoy/joykit/hooks';
import { BULB_COLORS, StyledHolidayLights } from './HolidayLights.styles';

const BULBS = [
  { x: 9, phase: 0 },
  { x: 27, phase: 1 },
  { x: 45, phase: 2 },
  { x: 63, phase: 3 },
  { x: 81, phase: 0 },
  { x: 99, phase: 1 },
] as const;

type Props = Readonly<{
  /** `bar`: a desktop bar tab, hidden below md. `strip`: a tab in the mega nav's mobile strip. */
  placement?: 'bar' | 'strip';
}>;

export const HolidayLights = ({ placement = 'bar' }: Props) => {
  const filterId = useJoyId(undefined, 'holiday-lights-glow');

  return (
    <StyledHolidayLights
      className={`holiday-lights--${placement}`}
      width={108}
      height={16}
      viewBox="0 0 108 16"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <filter
          id={filterId}
          x="-100%"
          y="-100%"
          width="300%"
          height="300%"
        >
          <feGaussianBlur stdDeviation="1.6" />
        </filter>
      </defs>
      <path
        className="holiday-lights__wire"
        d="M0 .5Q18 11 36 .5Q54 11 72 .5Q90 11 108 .5"
      />
      {[0, 1].map(group => (
        <g
          key={group}
          className={`holiday-lights__glow holiday-lights__glow--${group === 0 ? 'a' : 'b'}`}
          filter={`url(#${filterId})`}
        >
          {BULBS.filter((_, index) => index % 2 === group).map(bulb => (
            <ellipse
              key={bulb.x}
              className={`holiday-lights__bulb holiday-lights__bulb--p${bulb.phase}`}
              cx={bulb.x}
              cy={8.6}
              rx={4.8}
              ry={5.6}
              fill={BULB_COLORS[bulb.phase]}
            />
          ))}
        </g>
      ))}
      {BULBS.map(bulb => (
        <g key={bulb.x}>
          <rect
            className="holiday-lights__socket"
            x={bulb.x - 1.2}
            y={4}
            width={2.4}
            height={2}
            rx={0.4}
          />
          <ellipse
            className={`holiday-lights__bulb holiday-lights__bulb--p${bulb.phase}`}
            cx={bulb.x}
            cy={8.6}
            rx={2.2}
            ry={3}
            fill={BULB_COLORS[bulb.phase]}
          />
        </g>
      ))}
    </StyledHolidayLights>
  );
};
